const t = "_active_oksbw_52", e = {
  "top-bar": "_top-bar_oksbw_1",
  "top-bar--items": "_top-bar--items_oksbw_24",
  "top-bar--items--item": "_top-bar--items--item_oksbw_31",
  active: t,
  "top-bar--items--item-label": "_top-bar--items--item-label_oksbw_55"
};
export {
  t as active,
  e as default
};
